import ErrorReporter from '#/lib/ErrorReporter';
import resolveErrorMessage from '@jucy-nakuru/common/lib/errorHandler';
import { FORM_ERROR } from 'final-form';

export const exceptionToFormError = async (e: Error): Promise<{ [key: string]: string }> => {
    ErrorReporter.captureError(e);
    return {
        [FORM_ERROR]: await resolveErrorMessage(e),
    };
};
